export default __webpack_public_path__ + "static/media/art-blk-3.c137b829.png";